import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'jalali-moment';

@Pipe({
  name: 'jalaliConvertor'
})
export class JalaliConvertorPipe implements PipeTransform {

  transform(value: any, args?: any): unknown {
    if (value && args === 'date') {
      return moment.unix(value / 1000).locale('fa').format('YYYY/MM/DD');
    }
    return moment.unix(value / 1000).locale('fa').format('YYYY/MM/DD - HH:mm');
  }

}
